import $ from 'jquery';

/**
 * On small screens the open mobile menu would sit under the embedded booking
 * engine (#HuBOL), so the engine is faded out while the menu is open.
 */
export function initMobileMenuBolOverlay() {
    if (!window.matchMedia('(max-width: 500px)').matches) return;

    $('.navbar-toggler').click(function () {
        $('#HuBOL').addClass('opacity-0').removeClass('opacity-100');
    });

    $('.navbar-collapse .btn-close').click(function () {
        $('#HuBOL').removeClass('opacity-0').addClass('opacity-100');
    });
}
